<!--
  MainContent.vue
    Main Content Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <v-app>
    <!-- ローディング画面 -->
    <loading ref="loading"></loading>

    <!-- Top Navigation Bar -->
    <navbar
      @showLoading="showLoadingFunc"
      @hideLoading="hideLoadingFunc"
    ></navbar>

    <!-- Main Contents -->
    <v-content class="hm-iphonex-notch-ma">
      <!-- keep-aliveで行先リストはキャッシュ使う(パフォーマンス対策) -->
      <keep-alive include="WhereaboutsList">
        <router-view
          @showLoading="showLoadingFunc"
          @hideLoading="hideLoadingFunc"
        ></router-view>  <!-- @Memo ここにページが埋め込まれる -->
      </keep-alive>
    </v-content>

    <!-- Bottom Navigation Bar -->
    <!--<bottom-nav />-->

    <page-trans-btn />

    <!-- サーバ通信状態表示Snackbar
    <info-snackbar ref="infoSnackbar">
      <div slot="msg">{{ $t("infomsg.getlist") }}</div>
    </info-snackbar> -->
    <!-- テレワーク終了未送信Message -->
    <info-dialog ref="SystemInfoDialog">
      <div slot="msg">
        勤怠データを入力し忘れていませんか？<br>
        勤務開始したまま、24時間以上入力されていません。<br>
      </div>
    </info-dialog>
    <!-- データ送信失敗Alart -->
    <errorinfo-dialog ref="errorInfoDialog">
      <div slot="msg">{{ $t("errmsg.rcvfailed") }}</div>
    </errorinfo-dialog>
  </v-app>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { mapState } from 'vuex'
import { isNullorUndefined } from '@/common'
import { ROUTE_NAME, ROUTE_PATH } from '@/router/routes'
import Navbar from '@/components/Navbar'
import PageTransBtn from '@/components/PageTransBtn'
import BottomNav from '@/components/BottomNav'
import ErrorInfoDialog from '@/components/dialogs/ErrorInfoDialog'
import SystemInfoDialog from '@/components/dialogs/SystemInfoDialog'
//import InfoSnackbar from '@/components/parts/InfoSnackbar'
import Loading from '@/components/parts/Loading'

export default {
  // navigation guard
  /*
  beforeRouteEnter (to, from, next) {
    next()
  },
  */
  name: 'App',
  components: {
    'navbar': Navbar,
    'bottom-nav': BottomNav,
    'page-trans-btn': PageTransBtn,
    //'info-snackbar': InfoSnackbar,
    'errorinfo-dialog': ErrorInfoDialog,
    'info-dialog': SystemInfoDialog,
    'loading': Loading
  },
  data: () => ({
  }),
  mounted: async function () {
    this.$log.debug('# MainContent')
    this.$store.commit('setIsWhereaboutsPage', true)   // 行動予定一覧の更新を行う

    // 起動時処理 各コンポーネントに必要なデータをそろえておく
    await this.onContentInitialize()  // サーバからのデータ取得をawaitで待つ

    // 初期画面判定
    if (this.isMobile) {
      // Device利用可否判定(ReadyにならないとGeoLocationが使用できない：Cordova仕様)
      document.addEventListener('deviceready', this.onDeviceReady, false)

      // ログインユーザの行先情報を取得
      const login_id = this.$store.getters.loginUserId
      await this.$store.dispatch(
        'aSelectUser',
        {
          companyId: this.$store.getters.loginUserCompanyId,
          memberId: login_id,
        })

      // テレワーク勤務中社員リストを取得
      /*await this.$store.dispatch(
        'aGetTeleworkingUserList',
        this.$store.getters.loginUserCompanyId
      )*/

      this.$router.push({
        name: ROUTE_NAME.ROUTE_WHEREABOUTS_INFO,
        params: { id: login_id }
      })
    }
    else {
      this.$router.push(ROUTE_PATH.ROUTE_WHEREABOUTS_LIST)
    }
  },
  destroyed: function () {
    this.$log.debug('# MainContent')
  },
  computed: {
    ...mapState({
      isMobile: state => state.sIsMobile
    })
  },
  methods: {
    // -------------------------------------------------------------------------
    // 起動時処理
    onContentInitialize: async function () {
      const companyId = this.$store.getters.loginUserCompanyId
      if (isNullorUndefined(companyId)) {
        this.$log.error('company id is null or undefined.')
        // エラーダイアログの表示
        this.$refs.errorInfoDialog.$emit('show')
        return
      }

      //this.$refs.infoSnackbar.$emit('show')
      this.showLoadingFunc()

      // ユーザ情報取得
      // すぐにこの情報を使わないのでawaitしない
      const user_res = this.$store.dispatch('aGetUserList', companyId)
      if (user_res.error) {
        this.$log.warn('get user list error ' + user_res.status)
        this.$refs.errorInfoDialog.$emit('show')
        return
      }

      // 行先一覧取得
      const place_res = await this.$store.dispatch('aGetPlaceList', companyId)
      if (place_res.error) {
        this.$log.warn('get place list error ' + place_res.status)
        this.$refs.errorInfoDialog.$emit('show')
        return
      }
      // 在席状態一覧取得
      const presence_res = await this.$store.dispatch('aGetPresenceStatusList', companyId)
      if (presence_res.error) {
        this.$log.warn('get presence list error ' + presence_res.status)
        this.$refs.errorInfoDialog.$emit('show')
        return
      }
      // Section List
      const section_res = await this.$store.dispatch('aGetSectionList', companyId)
      if (section_res.error) {
        this.$log.warn('get section list error ' + section_res.status)
        this.$refs.errorInfoDialog.$emit('show')
        return
      }
      // Group List
      const group_res = await this.$store.dispatch('aGetGroupList', companyId)
      if (group_res.error) {
        this.$log.warn('get group list error ' + group_res.status)
        this.$refs.errorInfoDialog.$emit('show')
        return
      }
      // Class List
      const class_res = await this.$store.dispatch('aGetClassList', companyId)
      if (class_res.error) {
        this.$log.warn('get class list error ' + class_res.status)
        this.$refs.errorInfoDialog.$emit('show')
        return
      }

      // テレワーク勤務中で、前回勤務データ送信してから24時間経過した場合
      if (this.$store.getters.loginUserInfo.teleworking_over_flg === 1) {
        this.$refs.SystemInfoDialog.$emit('show')
      }

      //this.$refs.infoSnackbar.$emit('hide')
      this.hideLoadingFunc()
    },
    // -------------------------------------------------------------------------
    // 画面サイズ判定
    checkDisplaySize: function () {
      this.$store.commit('setIsMobile', this.$vuetify.breakpoint.xsOnly)
    },
    // -------------------------------------------------------------------------
    onDeviceReady: function () {
      this.$log.debug('Device Ready !')
      this.$store.commit('setIsDeviceReady', true)
      if (navigator.geolocation) {
        // GNSS利用可能状態にする
        this.$store.dispatch('changeGnssReady', true)
      }
      // back key
      //document.addEventListener('backbutton', this.onBackKeyDown, false)
    },
    // -------------------------------------------------------------------------
    onBackKeyDown: function () {
      navigator.notification.confirm(
        'Exit from this application ?',
        this._confirmCallback,
        'Exit Confirm',
        ['Exit', 'Cancel'])
    },
    // -------------------------------------------------------------------------
    _confirmCallback: function (id) {
      if (id === 1) {
        navigator.app.exitApp()
      }
    },
    // -------------------------------------------------------------------------
    showLoadingFunc: function () {
      this.$refs.loading.$emit('show')
    },
    hideLoadingFunc: function () {
      this.$refs.loading.$emit('hide')
    },
  }
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MainContent.vue